import { observer } from 'mobx-react-lite';
import { lazy, ReactElement, Suspense } from 'react';

import { LoadingView } from '../../../components/loadingView';
import { useSDK } from '../..';

const Controller = lazy(() => import('../'));

const Component = (): ReactElement => {
	const { uiStateStore } = useSDK();
	return (
		<Suspense fallback={uiStateStore.opened ? <LoadingView /> : null}>
			<Controller />
		</Suspense>
	);
};

export const ControllerLazy = observer(Component);
